/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useRef } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { useSiniester } from "../../../redux/siniesterReducer";
import { ArrowDownIcon, CloseBlueIcon } from "../../../assets/icons/Icons";
import {
  ajustador,
  estatusSiniestro,
  experto,
} from "../../../constants/capturaSiniestro";
import { InputDatePicker, InputFile, InputSelect, InputText } from "../../form";
import { LoadingDocuments } from "../../ui";
import {
  CREATE_SINIESTRO,
  CREATE_SEGUIMIENTO,
  GET_STATUS_SINIESTRO,
  UPLOAD_FILE_DOCUMENT,
  CREATE_DOC_SINIESTRO,
  CREATE_DOC_REMIDER,
  GET_DATES_VALIDATION,
} from "../../../services/siniestro";
import { GET_ALL_EXPERTS } from "../../../services/experts";
import { GET_ALL_ADJUSTERS } from "../../../services/adjuster";
import { useDropzone } from "react-dropzone";
import ModalContainer from "../../ModalContainer";

export const General = ({ contract, generalOpen, setGeneralOpen }) => {
  const [allDataInputs, setAllDataInputs] = useState([]);
  const [resInputsFollow, setResInputsFollow] = useState([]);
  const [showSeguimiemto] = useState(true);
  // Subida de archivos
  const [valueInput, setValueInput] = useState("Ok");
  const [urlFile, setUrlFile] = useState([]);
  const [allFilesFoll, setAllFilesFoll] = useState([]);
  const [allFilesGen, setAllFilesGen] = useState([]);
  const [siniestroId, setSiniestroId] = useState("");
  const [succesData, setSuccesData] = useState(false);
  const [errorDocuments, setErrorDocuments] = useState("");
  const [allInputSinester, setAllInputSinester] = useState(null);
  const [tempData, setTempData] = useState(null);
  const { siniesterState, setSiniester } = useSiniester();
  const onButton = () => {
    if (contract?.contrato_id) setGeneralOpen((prev) => !prev);
  };

  // notificación de nuevo siniestro
  const [notification, setNotification] = useState({
    show: false,
    created: false,
    customMessage: undefined,
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({});

  const getUrlData = (key, index) => {
    const fileGeneral = urlFile.filter((item) => item.keyword === key);
    const result =
      fileGeneral.length > 0 ? fileGeneral[index].url.Location : "";
    const resultName =
      fileGeneral.length > 0 ? fileGeneral[index].fileName : "";
    return {
      url: result,
      nameFile: resultName,
    };
  };

  // Queries
  const [getStatusSiniestro] = useLazyQuery(GET_STATUS_SINIESTRO, {
    fetchPolicy: "network-only",
    onCompleted({ getStatusSiniestro }) {
      if (getStatusSiniestro.statusCode === 200) {
        const result = JSON.parse(getStatusSiniestro.response);
        const dataOptionClient = result.map((status) => ({
          titleNameArr: "estatusSiniestro",
          label: status.valor,
          value: status.estatus_siniestro_id,
        }));
        //filter to get Pendiente status
        const filterStatus = dataOptionClient.filter(
          (item) => item.label === "Pendiente"
        );
        setAllDataInputs((data) => [...data, filterStatus]);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [getAllExperts] = useLazyQuery(GET_ALL_EXPERTS, {
    fetchPolicy: "network-only",
    onCompleted({ getAllExperts }) {
      if (getAllExperts.statusCode === 200) {
        const result = JSON.parse(getAllExperts.response);
        const dataOptionClient = result.map((status) => ({
          titleNameArr: "experto",
          label: status.razon_social,
          value: status.experto_id,
        }));
        setAllDataInputs((data) => [...data, dataOptionClient]);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });
  const [getAllAdjusters] = useLazyQuery(GET_ALL_ADJUSTERS, {
    fetchPolicy: "network-only",
    onCompleted({ getAllAdjusters }) {
      if (getAllAdjusters.statusCode === 200) {
        const result = JSON.parse(getAllAdjusters.response);
        const dataOptionClient = result.map((status) => ({
          titleNameArr: "ajustador",
          label: status.razon_social,
          value: status.ajustador_id,
        }));
        setAllDataInputs((data) => [...data, dataOptionClient]);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });
  // eslint-disable-next-line
  const [getDatesValidation] = useLazyQuery(GET_DATES_VALIDATION, {
    fetchPolicy: "network-only",
    async onCompleted({ getDatesValidation }) {
      if (getDatesValidation.statusCode === 200) {
        const data = tempData;
        if (allFilesGen.length > 0) {
          await handleUploadMutation(allFilesGen, "inputGeneral");
        }
        if (allFilesFoll.length > 0 && showSeguimiemto) {
          await handleUploadMutation(allFilesFoll, "inputSeguimiento");
        }
        setResInputsFollow(data);
        const siniestroInput = {
          input: {
            fecha: `${data.fechaSiniestro}`,
            causa: data.causaSiniestro,
            fecha_emi: `${data.fechaReporteAviso}`,
            lugar: data.lugarSiniestro,
            consecutivo_cliente: data.consecutivoCliente,
            estatus_siniestro_id: data.estatusSiniestro,
            contrato_id: contract.contrato_id,
            fechaContract: contract.fecha_fin,
            experto_id: data.experto,
            ajustador_id: data.ajustador,
          },
        };
        setAllInputSinester(siniestroInput);
      } else if (getDatesValidation.statusCode === 400) {
        alert("error");
      } else if (getDatesValidation.statusCode === 422) {
        setNotification({
          show: true,
          created: false,
          customMessage: "La fecha del siniestro/reporte sobrepasa el límite de 30 días o de vigencia del contrato."
        });
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  // Mutations
  const [createSeguimiento] = useMutation(CREATE_SEGUIMIENTO, {
    onCompleted({ createSeguimiento }) {
      if (createSeguimiento.statusCode === 200) {
        const result = JSON.parse(createSeguimiento.response);
        if (allFilesFoll.length > 0) {
          for (let i = 0; i < allFilesFoll.length; i++) {
            const urlData = getUrlData("inputSeguimiento", i);
            const docRemiderInput = {
              input: {
                url: urlData.url,
                nombre_archivo: urlData.nameFile,
                recordatorio_id: result.recordatorio_id,
              },
            };
            createDocRemider({
              variables: docRemiderInput,
            });
          }
        }
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const [createDocumentalSiniestro] = useMutation(CREATE_DOC_SINIESTRO);

  const [createDocRemider] = useMutation(CREATE_DOC_REMIDER);

  const [uploadDocuments, { loading: loadingDocuments }] = useMutation(
    UPLOAD_FILE_DOCUMENT,
    {
      fetchPolicy: "no-cache",
      onCompleted({ uploadDocuments }) {
        if (uploadDocuments.statusCode === 200) {
          const urlDocument = JSON.parse(uploadDocuments.response);
          setUrlFile((data) => [...data, urlDocument]);
        }
        if (uploadDocuments.statusCode === 400) {
          setErrorDocuments(uploadDocuments.error);
        }
      },
      onError(err) {
        console.log("Error: ", err);
        setErrorDocuments("Error al subir archivo");
      },
    }
  );

  // Generando seguimiento
  const createFollow = async ({ resInputsFollow, resCreateSiniestro }) => {
    const seguimientoInput = {
      input: {
        nota: resInputsFollow.notasSeguimiento,
        fecha: `${resInputsFollow.fechaSeguimiento}`,
        siniestro_id: resCreateSiniestro.siniestro_id,
        fechaContract: contract.fecha_fin,
      },
    };
    await createSeguimiento({
      variables: seguimientoInput,
    });
  };

  const handleDocSinester = async (data) => {
    for (let i = 0; i < allFilesGen.length; i++) {
      const urlData = getUrlData("inputGeneral", i);
      await createDocumentalSiniestro({
        variables: {
          input: {
            url: urlData.url,
            nombre_archivo: urlData.nameFile,
            siniestro_id: data.siniestro_id,
          },
        },
      });
    }
  };

  const [createSiniestro] = useMutation(CREATE_SINIESTRO, {
    onCompleted({ createSiniestro }) {
      if (createSiniestro.statusCode === 200) {
        const resCreateSiniestro = JSON.parse(createSiniestro.response);
        setSiniester(resCreateSiniestro);
        setNotification({ show: true, created: true });
        setTimeout(() => {
          setNotification({ show: false, created: true });
        }, [3500]);

        // Guardado de documentales siniestros
        if (allFilesGen.length > 0) {
          handleDocSinester(resCreateSiniestro);
        }
        // Creando seguimiento
        showSeguimiemto &&
          createFollow({ resInputsFollow, resCreateSiniestro });
      } else if (createSiniestro.statusCode === 422) {
        // console.log("422");
        setNotification({
          show: true,
          created: false,
          customMessage: "El siniestro ya existe",
        });
        // setTimeout(() => {
        //   setNotification({ show: false, created: true, customMessage: "" })
        // }, [3500])
      }
    },
    onError(err) {
      console.log("Error: ", err);
      setNotification({ show: true, created: false });
      setTimeout(() => {
        setNotification(false);
      }, [3500]);
    },
  });

  // Carga de archivos
  const onClickInput = (data) => {
    setValueInput(data);
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      let valueInputOne;
      let valueInputTwo;
      const newAcceptedFiles = acceptedFiles;
      if (newAcceptedFiles.length > 1) {
        for (let i = 0; i < newAcceptedFiles.length; i++) {
          if (valueInput === "inputUploadGeneral") {
            setAllFilesGen((data) => [...data, ...[newAcceptedFiles[i]]]);
          }
          if (valueInput === "inputUploadSeguimiento") {
            setAllFilesFoll((data) => [...data, ...[newAcceptedFiles[i]]]);
          }
        }
      } else {
        if (valueInput === "inputUploadGeneral") {
          valueInputOne = acceptedFiles;
          setAllFilesGen([...allFilesGen, ...valueInputOne]);
        }

        if (valueInput === "inputUploadSeguimiento") {
          valueInputTwo = acceptedFiles;
          setAllFilesFoll([...allFilesFoll, ...valueInputTwo]);
        }
      }
    },
    [allFilesGen, valueInput, allFilesFoll]
  );

  const removeFile = (index) => () => {
    const updatedFiles = [...allFilesGen];

    updatedFiles.splice(updatedFiles.indexOf(index), 1);

    setAllFilesGen(updatedFiles);
  };

  const removeFileSeg = (index) => () => {
    const updatedFiles = [...allFilesFoll];

    updatedFiles.splice(updatedFiles.indexOf(index), 1);

    setAllFilesFoll(updatedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  const rootProps = siniestroId === "" && getRootProps();

  /* const handleUploadMutation = async (dataFile, key) => {
    const uploadPromises = dataFile.map((dataArr) =>
      uploadDocuments({
        variables: {
          fileDocument: [dataArr[0]],
          keyword: key,
          fileSize: dataArr[0].size,
        },
      })
    );
    await Promise.all(uploadPromises);
  }; */

  const handleUploadMutation = async (dataFile, key) => {
    // eslint-disable-next-line
    for (const [i, dataArr] of dataFile.entries()) {
      try {
        await uploadDocuments({
          variables: {
            fileDocument: [dataArr],
            keyword: key,
            fileSize: dataArr.size,
          },
        });
      } catch (error) {
        console.log(`Error al subir el archivo ${dataArr.path}:`, error);
        setErrorDocuments(`Error al subir el archivo ${dataArr.path}`);
      }
    }
  };
  //console.log(contract);
  const handleSinester = async () => {
    setSiniestroId("1");

    await createSiniestro({
      variables: allInputSinester,
    });
    setSuccesData(true);
  };

  // Generando Siniestro
  const onSubmit = async (data) => {
    console.log(data);
    if (allFilesGen.length === 0) {
      return setNotification({
        show: true,
        created: false,
        customMessage: "Campo documentales obligatorio",
      });
    }
    await setTempData(data);
    const statusContract = ["Pendiente", "Pagada", "Cancelada"];
    await getDatesValidation({
      variables: {
        emiDateContract: `${contract.fecha_emi}`,
        dateReport: `${data.fechaReporteAviso}`,
        dateEmi: `${data.fechaSiniestro}`,
        dateFollow: `${data.fechaSeguimiento}`,
        startDateContract: `${contract.fecha_ini}`,
        endDateContract: `${contract.fecha_fin}`,
        status: `${ contract.valor_est_cont || statusContract[contract.estatus_contrato_id - 1]}`,
      },
    });
  };

  useEffect(() => {
    if (errorDocuments === "" && allInputSinester) {
      handleSinester();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allInputSinester]);

  useEffect(() => {
    getStatusSiniestro();
    getAllExperts();
    getAllAdjusters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const expertRef = useRef();
  const adjusterRef = useRef();
  const statusRef = useRef();
  useEffect(() => {
    if (siniesterState?.siniestro_id) {
      setSiniestroId(siniesterState.siniestro_id);
    } else {
      setSiniestroId("");
      reset({
        fechaSiniestro: null,
        causaSiniestro: "",
        fechaReporteAviso: null,
        lugarSiniestro: "",
        consecutivoCliente: "",
        estatusSiniestro: "",
        notasSeguimiento: "",
      });
      expertRef?.current?.clearValue();
      adjusterRef?.current?.clearValue();
      statusRef?.current?.clearValue();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siniesterState]);

  useEffect(() => {
    if (contract?.contrato_id) {
      setGeneralOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract?.contrato_id]);

  useEffect(() => {
    setUrlFile([]);
    setAllFilesFoll([]);
    setAllFilesGen([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract]);

  return (
    <>
      <ModalContainer
        showModal={notification.show}
        closeModal={() =>
          setNotification({
            show: false,
            created: false,
            customMessage: "",
          })
        }
      >
        <TextNotification created={notification.created}>
          {notification.created
            ? notification.customMessage || "Siniestro Agregado"
            : notification.customMessage || "Hubo un error, inténtelo de nuevo"}
        </TextNotification>
      </ModalContainer>
      <LoadingDocuments
        loadingDocuments={loadingDocuments}
        succesData={succesData}
        setSuccesData={setSuccesData}
        errorDocuments={errorDocuments}
        setErrorDocuments={setErrorDocuments}
      />
      <ModuleContainer open={generalOpen}>
        <Header
          onClick={() => {
            onButton();
          }}
        >
          <ModuleTitle>General</ModuleTitle>
          <ArrowDownIcon className="arrow" />
        </Header>
        <Content className="content">
          <Divider />
          <ModuleTitle
            style={{ color: "var(--primary-royal-blue)", marginBottom: "20px" }}
          >
            Información
          </ModuleTitle>
          {siniestroId !== "" && (
            <NumeroSiniestro>{`Número del Siniestro: # ${siniestroId}`}</NumeroSiniestro>
          )}
          <form id="form-siniester" onSubmit={handleSubmit(onSubmit)}>
            <RowContainer>
              <InputDatePicker
                label="Fecha de siniestro"
                control={control}
                name="fechaSiniestro"
                errorMessage={errors.fechaSiniestro?.type}
                readOnly={siniestroId !== ""}
              />
              <InputDatePicker
                label="Fecha de reporte/aviso"
                control={control}
                name="fechaReporteAviso"
                errorMessage={errors.fechaReporteAviso?.type}
                readOnly={siniestroId !== ""}
              />
              <InputText
                label="Consecutivo de cliente"
                name="consecutivoCliente"
                type="text"
                control={control}
                placeholder="Consecutivo"
                register={{ ...register("consecutivoCliente") }}
                errorMessage={errors.consecutivoCliente?.type}
                readOnly={siniestroId !== ""}
              />
            </RowContainer>
            <div style={{ marginBottom: "12px" }}>
              <InputText
                label="Causa del siniestro"
                name="causaSiniestro"
                type="text"
                control={control}
                placeholder="Causa"
                register={{ ...register("causaSiniestro") }}
                errorMessage={errors.causaSiniestro?.type}
                multiline={true}
                readOnly={siniestroId !== ""}
              />
            </div>
            <GridContainer>
              <InputText
                label="Lugar de siniestro"
                name="lugarSiniestro"
                type="text"
                control={control}
                placeholder="Lugar"
                register={{ ...register("lugarSiniestro") }}
                errorMessage={errors.lugarSiniestro?.type}
                readOnly={siniestroId !== ""}
              />
              <InputSelect
                label="Estatus del siniestro"
                name="estatusSiniestro"
                customRef={statusRef}
                optionData={allDataInputs}
                options={estatusSiniestro}
                control={control}
                errorMessage={errors.estatusSiniestro?.type}
                placeholder="Estatus"
                readOnly={siniestroId !== ""}
              />
              <InputSelect
                label="Experto"
                name="experto"
                customRef={expertRef}
                optionData={allDataInputs}
                options={experto}
                control={control}
                required={false}
                errorMessage={errors.experto?.type}
                placeholder="Experto"
                readOnly={siniestroId !== ""}
              />
              <InputSelect
                label="Ajustador"
                name="ajustador"
                customRef={adjusterRef}
                optionData={allDataInputs}
                options={ajustador}
                control={control}
                required={false}
                errorMessage={errors.ajustador?.type}
                placeholder="Ajustador"
                readOnly={siniestroId !== ""}
              />
              <div>
                <div {...rootProps}>
                  <InputFile
                    inputProps={getInputProps()}
                    label="Anexos documentales"
                    placeholder="Documentales"
                    onClickInput={onClickInput}
                    idInput={"inputUploadGeneral"}
                  />
                </div>
                <DocsContainer>
                  {allFilesGen.map((file, i) => (
                    <DocButton key={i}>
                      <CloseBlueIcon onClick={removeFile(i)} />
                      <p className="overflow-ellipsis">{file?.path}</p>
                    </DocButton>
                  ))}
                </DocsContainer>
              </div>
            </GridContainer>
            <SubModuleContainer>
              <ModuleTitle style={{ color: "var(--primary-royal-blue)" }}>
                Programar seguimiento
              </ModuleTitle>
            </SubModuleContainer>
            <SeguimientoContent show={showSeguimiemto}>
              <InputText
                label="Notas de seguimiento"
                name="notasSeguimiento"
                type="text"
                control={control}
                placeholder="Notas"
                register={{ ...register("notasSeguimiento") }}
                errorMessage={errors.notasSeguimiento?.type}
                required={true}
                readOnly={siniestroId !== ""}
              />
              <div style={{ height: "12px" }} />
              <GridContainer>
                <InputDatePicker
                  label="Fecha de seguimiento"
                  control={control}
                  name="fechaSeguimiento"
                  errorMessage={errors.fechaSeguimiento?.type}
                  required={true}
                  readOnly={siniestroId !== ""}
                />
                <div>
                  <div {...rootProps}>
                    <InputFile
                      {...getInputProps()}
                      label="Anexos documentales"
                      placeholder="Documentales"
                      onClickInput={onClickInput}
                      idInput={"inputUploadSeguimiento"}
                      required={true}
                    />
                  </div>
                  <DocsContainer>
                    {allFilesFoll.map((file, i) => (
                      <DocButton key={i}>
                        <CloseBlueIcon onClick={removeFileSeg(i)} />
                        <p className="overflow-ellipsis">{file?.path}</p>
                      </DocButton>
                    ))}
                  </DocsContainer>
                </div>
              </GridContainer>
            </SeguimientoContent>
          </form>
        </Content>
      </ModuleContainer>
    </>
  );
};

const TextNotification = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ created }) => (created ? "var(--primary-pistachio)" : "red")};
  margin: 0 20px;
`;

const ModuleContainer = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
  margin-bottom: 30px;
  @media only screen and (max-width: 1280px) {
    width: 90vw;
    padding: 40px 20px;
  }
  //Divider
  & > .content {
    display: ${(props) => (props.open ? "block" : "none")};
  }
  & .arrow {
    transition: 500ms;
    transform: ${(props) => (props.open ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;

const Header = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const NumeroSiniestro = styled.p`
  color: var(--primary-royal-blue);
  font-size: 18px;
  font-weight: 700;
  background-color: var(--secondary-alice-blue);
  padding: 12px 20px;
  width: fit-content;
  border-radius: 12px;
  margin-bottom: 32px;
`;

const Content = styled.div``;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 24px 0;
  background-color: var(--primary-pistachio);
`;

const SubModuleContainer = styled.div`
  padding: 20px 0;
  display: flex;
  gap: 30px;
  align-items: center;
`;

const SeguimientoContent = styled.div`
  display: ${({ show }) => (show ? "block" : "none")};
`;

//---- FORM ----//
const RowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 12px;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 8px;
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const GridContainer = styled.div`
  display: grid;
  justify-content: space-between;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 12px;
  column-gap: 32px;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 8px;
  }
  @media only screen and (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const DocsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const DocButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid var(--secondary-maya-blue);
  background-color: var(--secondary-alice-blue);
  padding: 4px 14px 4px 4px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--primary-royal-blue);
  font-size: 12px;
  transition: 300ms;
  text-decoration: underline;
  font-weight: 600;
  & svg {
    width: 22px;
    height: 22px;
  }
  &:hover {
    opacity: 0.8;
  }
  .overflow-ellipsis {
    text-overflow: ellipsis;
  }
  p {
    width: 90px;
    white-space: nowrap;
    overflow: hidden;
  }
`;
